import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { LazyComponent } from "../../FundPages/core/LazyComponent";
import SecondaryNav from '../blocks/secondaryNav/SecondaryNav';

const ContentAreaBlock = React.lazy(() => import('../../FundPages/blocks/ContentAreaBlock'));
const HTMLBlock = React.lazy(() => import('../../FundPages/blocks/HtmlBlock'));
const HistoPricesBlock = React.lazy(() => import('../Components/HistoPricesBlock/HistoPricesBlock'));
const PremiumDiscountHistoryBlock = React.lazy(()=> import('../../FundPages/Components/PremiumDiscountHistoryBlock/PremiumDiscountHistoryBlock'));
const EmptyComponent = React.lazy(()=> import('../../FundPages/Components/EmptyComponent/EmptyComponent'));
const PerformanceHistoryBlock = React.lazy(()=>import('../../FundPages/Components/PerformanceHistoryBlock/PerformanceHistoryBlock') )
const HoldingsBlock = React.lazy(()=>import('../../FundPages/Components/HoldingsBlock/HoldingsBlock'))
const NavDistributionsBlock = React.lazy(()=>import('../../FundPages/Components/NavDistributionsBlock/NavDistributionsBlock'))
const HoldingsWeightingsChartBlock = React.lazy(()=>import('../../FundPages/Components/HoldingsWeightingsChartblock/HoldingsWeightingsChartBlock'))
const HypotheticalChartBlock = React.lazy(()=>import('../../FundPages/Components/HypotheticalChartBlock/HypotheticalChartBlock'))
const PerformanceYearlyReturnsBlock = React.lazy(()=>import('../../FundPages/Components/PerformanceYearlyReturnsBlock/PerformanceYearlyReturnsBlock'))
const MorningstarRatingBlock = React.lazy(()=>import('../../FundPages/Components/MorningstarRatingBlock/MorningstarRatingBlock'))
const PersonUsBlock = React.lazy(() => import('../../FundPages/Components/PersonUsBlock/PersonUsBlock'))
const FundDetailsBlock = React.lazy(() => import('../../FundPages/Components/FundDetailsBlock/FundDetailsBlock'))
const FundDetailsLiteratureBlock = React.lazy(() => import('../../FundPages/Components/FundDetailsLiteratureBlock/FundDetailsLiteratureBlock'))
const DiscountViolationBlock = React.lazy(() => import('../../FundPages/Components/DiscountViolationBlock/DiscountViolationBlock'))
const IndexBenchmarkChartBlock = React.lazy(() => import('../../FundPages/Components/IndexBenchmarkChartBlock/IndexBenchmarkChartBlock'))
const HoldingsCreditQualityBlock = React.lazy(()=>import('../../FundPages/Components/HoldingsCreditQualityBlock/HoldingsCreditQualityBlock'))
const HistoPricesChartBlock = React.lazy(()=>import('../../FundPages/Components/HistoPricesChartBlock/HistoPricesChartBlock'))
const IndexFundamentalsBlock = React.lazy(()=>import('../../FundPages/Components/IndexFundamentalsBlock/IndexFundamentalsBlock'))
const AnalyticsCustomBlock = React.lazy(()=>import('../../FundPages/Components/AnalyticsCustomBlock/AnalyticsCustomBlock'))
const NavInformationBlock = React.lazy(()=>import('../../FundPagesEU/Components/NavInformationBlock/NavInformationBlock'))
const FundFeesChargesBlock = React.lazy(()=>import('../../FundPages/Components/FundFeesAndChargesBlock/FundFeesChargesBlock'))
const AccountMinimumBlock = React.lazy(()=>import('../../FundPages/Components/AccountMinimumBlock/AccountMinimumBlock'))
const FundExpensesBlock = React.lazy(()=>import('../../FundPages/Components/FundExpensesBlock/FundExpensesBlock'))
const PerformanceAnnualReturnsBlock = React.lazy(()=>import('../../FundPages/Components/PerformanceAnnualReturnsBlock/PerformanceAnnualReturnsBlock'))
const HoldingsWeightingsBlock = React.lazy(() => import('../../FundPages/Components/HoldingsWeightingsBlock/HoldingsWeightingsBlock'))
const NavInformationUsBlock = React.lazy(() => import('../../FundPages/Components/NavInformationUsBlock/NavInformationUsBlock'))
const VideoUsBlock = React.lazy(() => import('../../FundPages/blocks/VideoUsBlock/VideoUsBlock'));
const RatingsBlock = React.lazy(() => import('../Components/RatingsBlock/RatingsBlock'));

const HTMLAuBlock = React.lazy(() => import('../blocks/HtmlAuBlock'));
const OneColumnAuBlock = React.lazy(() => import('../Components/OneColumnAuBlock/OneColumnAuBlock'))
const HoldingsPortfolioBlock = React.lazy(() => import('../Components/HoldingsPortfolioBlock/HoldingsPortfolioBlock'))

//Bots
const isCrawler = /bot|googlebot|crawler|spider|robot|crawling/i.test(navigator.userAgent);

const blockTypes = [
    {
        name: "SecondaryNav",
        tagName: "ve-fundpagesecondarynav",
        component: SecondaryNav,
        LoadImmediately: true
    },
    {
        name: "ContentAreaBlock",
        tagName: "ve-contentareablock",
        component: ContentAreaBlock,
        LoadImmediately: false,
        template: ""
    },
    {
        name: "HTMLBlock",
        tagName: "ve-htmlblock",
        component: HTMLBlock,
        LoadImmediately: false,
        template: ""
    },
    {
        name: "VideoUsBlock",
        tagName: "ve-videousblock",
        component: VideoUsBlock,
        LoadImmediately: false,
        template: ""
    },
    {
        name: "PersonUsBlock",
        tagName: "ve-contentareablock",
        component: PersonUsBlock,
        LoadImmediately: false,
        template: "PersonUsBlocks",
        IgnoreForCrawlers: true
    },
    {
        name: "HistoPricesBlock",
        tagName: "ve-histopricesblock",
        component: HistoPricesBlock,
        LoadImmediately: false
    },
    {
        name: "PremiumDiscountHistoryBlock",
        tagName: "ve-premiumdiscounthistoryblock",
        component: PremiumDiscountHistoryBlock,
        LoadImmediately: false
    },
    {
        name: "PerformanceHistoryBlock",
        tagName: "ve-performancehistoryblock",
        component: PerformanceHistoryBlock,
        LoadImmediately: false
    },
    {
        name: "HoldindsWeightingsChartBlock",
        tagName: "ve-holdingsweightingschartblock",
        component: HoldingsWeightingsChartBlock,
        LoadImmediately: false,
        ///IgnoreForCrawlers: true
    },
    {
        name: "PerformanceYearlyReturns",
        tagName: "ve-performanceyearlyreturnsblock",
        component: PerformanceYearlyReturnsBlock,
        LoadImmediately: false,
        IgnoreForCrawlers: true
    },
    {
        name: "HypotheticalChartBlock",
        tagName: "ve-hypotheticalchartblock",
        component: HypotheticalChartBlock,
        LoadImmediately: false,
        IgnoreForCrawlers: true
    },
    {
        name: "HoldingsBlock",
        tagName: "ve-holdingsblock",
        component: HoldingsBlock,
        LoadImmediately: false
    },
    {
        name: "NavDistributionsBlock",
        tagName: "ve-navdistributionsblock",
        component: NavDistributionsBlock
    },
    {
        name: "MorningstarRatingBlock",
        tagName: "ve-morningstarblock",
        component: MorningstarRatingBlock,
        LoadImmediately: false
    },
    {
        name: "FundDetailsBlock",
        tagName: "ve-fund-details-block",
        component: FundDetailsBlock,
        LoadImmediately: false,
        template: ""
    },
    {
        name: "FundDetailsLiteratureBlock",
        tagName: "ve-fund-details-block",
        template: "FundDetailsLiterature",
        component: FundDetailsLiteratureBlock,
        LoadImmediately: false
    },
    {
        name: "DiscountViolationBlock",
        tagName: "ve-discount-violation-block",
        component: DiscountViolationBlock,
        LoadImmediately: false
    },
    {
        name: "IndexBenchmarkChartBlock",
        tagName: "ve-indexbenchmarkschartblock",
        component: IndexBenchmarkChartBlock,
        LoadImmediately: false,
        IgnoreForCrawlers: true
    },
    {
        name: "HoldingsCreditQualityBlock",
        tagName: "ve-holdingscreditqualityblock",
        component: HoldingsCreditQualityBlock,
        LoadImmediately: false
    },
    {
        name: "HistoPricesChartBlock",
        tagName: "ve-histopricechartblock",
        component: HistoPricesChartBlock,
        LoadImmediately: false,
        IgnoreForCrawlers: true
    },
    {
        name: "IndexFundamentalsBlock",
        tagName: "ve-indexfundamentalsblock",
        component: IndexFundamentalsBlock,
        LoadImmediately: false
    },
    {
        name: "AnalyticsCustomBlock",
        tagName: "ve-analyticscustomblock",
        component: AnalyticsCustomBlock,
        LoadImmediately: false
    },
    {
        name: "NavInformationBlock",
        tagName: "ve-navinformationblock",
        component: NavInformationBlock,
        LoadImmediately: false
    },
    {
        name: "FundFeesChargesBlock",
        tagName: "ve-fundfeesandchargesblock",
        component: FundFeesChargesBlock,
        LoadImmediately: false
    },
    {
        name: "AccountMinimumBlock",
        tagName: "ve-onecolumnusblock",
        component: AccountMinimumBlock,
        LoadImmediately: false,
        template: "AccountMinimumBlock"
    },
    {
        name: "FundExpensesBlock",
        tagName: "ve-fundexpensesblock",
        component: FundExpensesBlock,
        LoadImmediately: false
    },
    {
        name: "PerformanceAnnualReturnsBlock",
        tagName: "ve-performanceannualreturnsblock",
        component: PerformanceAnnualReturnsBlock,
        LoadImmediately: false
    },
    {
        name: "HoldingsWeightingsBlock",
        tagName: "ve-holdingsweightingsblock",
        component: HoldingsWeightingsBlock,
        LoadImmediately: false
    },
    {
        name: "NavInformationUsBlock",
        tagName: "ve-navinformationblock",
        component: NavInformationUsBlock,
        LoadImmediately: false,
        template: "NavInformationUsBlock"
    },
    {
        name: "HTMLAuBlock",
        tagName: "ve-htmlaublock",
        component: HTMLAuBlock,
        LoadImmediately: false,
        template: ""
    },
    {
        name: "OneColumnAuBlock",
        tagName: "ve-onecolumnaublock",
        component: OneColumnAuBlock,
        LoadImmediately: false,
        IgnoreForCrawlers: true
    },
    {
        name: "HoldingsPortfolioBlock",
        tagName: "ve-holdingsportfolioblock",
        component: HoldingsPortfolioBlock,
        LoadImmediately: false,
        IgnoreForCrawlers: true
    },
    {
        name: "RatingsBlock",
        tagName: "ve-ratingblock",
        component: RatingsBlock,
        LoadImmediately: false
    },
    {
        name: "EmptyComponent",
        tagName: "ve-emptycomponent",
        component: EmptyComponent,
        LoadImmediately: false
    }
]

export function processMarkup(rootElem = document) {
    //If it is a crawler, remove the blocks that are too slow to load.
    let blockTypesToRender = blockTypes;
    if (isCrawler) {
        blockTypesToRender = blockTypes.filter(block => {
            return typeof(block.IgnoreForCrawlers) == "undefined" || block.IgnoreForCrawlers == false;
        })
    }

    for (const block of blockTypesToRender) {
        var containers = rootElem.getElementsByTagName(block.tagName)
        if (block.template != null) {
            containers = Array.from(containers).filter(x => x.dataset.template == block.template)
        }
        for (const container of containers) {
            const root = createRoot(container);
            const { component, LoadImmediately } = block;
            root.render(
                <Suspense fallback={<div className="component-loading">Loading...</div>}>
                    <LazyComponent component={component} rootElement={container} loadImmediately={LoadImmediately} />
                </Suspense>
            );
        }
    }
}